export default "__VITE_ASSET__oTzaBZDt__"